import { Bank } from "@app/types";
import HttpService from "@core/services/http/http.service";

class _BankService {
  public getBanks(money: number) {
    return HttpService.get<Bank[]>("/banks?money=" + money);
  }
}

const BankService = new _BankService();

export default BankService;
